import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc, query, collection, where, getDocs } from "firebase/firestore";
import Sidebar from "../components/Sidebar";
import DashboardNavbar from "../components/DashboardNavbar";
import StatCard from "../components/StatCard";
import ProjectList from "../components/ProjectList";
import QuickActions from "../components/QuickActions";
import { FaProjectDiagram, FaTasks, FaCheckCircle, FaDollarSign } from "react-icons/fa";
import "../styles/Dashboard.css";

function Dashboard() {
  const [stats, setStats] = useState({
    totalProjects: 0,
    activeProjects: 0,
    completedProjects: 0,
    totalEarnings: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      if (!auth.currentUser) {
        setLoading(false);
        return;
      }

      try {
        // Fetch user data from Firestore
        const userDoc = await getDoc(doc(db, "users", auth.currentUser.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();

          // Fetch projects assigned to user
          const projectsQuery = query(
            collection(db, "projects"),
            where("assignedTo", "==", auth.currentUser.uid)
          );
          const projectsSnapshot = await getDocs(projectsQuery);

          let totalProjects = 0;
          let activeProjects = 0;
          let completedProjects = 0;

          projectsSnapshot.forEach((doc) => {
            const project = doc.data();
            totalProjects++;
            if (project.status === "In Progress" || project.status === "QA") {
              activeProjects++;
            } else if (project.status === "Completed") {
              completedProjects++;
            }
          });

          // Fetch payments to calculate total earnings
          const paymentsQuery = query(
            collection(db, "payments"),
            where("userId", "==", auth.currentUser.uid)
          );
          const paymentsSnapshot = await getDocs(paymentsQuery);

          let totalEarnings = 0;
          paymentsSnapshot.forEach((doc) => {
            const payment = doc.data();
            if (payment.status === "Paid" || payment.status === "Released") {
              totalEarnings += payment.amount || 0;
            }
          });

          setStats({
            totalProjects,
            activeProjects,
            completedProjects,
            totalEarnings
          });
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <div className="dashboard-layout">
        <Sidebar />
        <div className="dashboard-main">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-main">
        <DashboardNavbar />

        <div className="stats-grid">
          <StatCard
            title="Total Projects"
            value={stats.totalProjects}
            change={`${stats.completedProjects} completed`}
            icon={<FaProjectDiagram />}
            color="#5B8DEF"
          />
          <StatCard
            title="Active Projects"
            value={stats.activeProjects}
            change="In progress"
            icon={<FaTasks />}
            color="#10B981"
          />
          <StatCard
            title="Completed"
            value={stats.completedProjects}
            change="Total completed"
            icon={<FaCheckCircle />}
            color="#F59E0B"
          />
          <StatCard
            title="Total Earnings"
            value={`₹${stats.totalEarnings.toLocaleString()}`}
            change="Platform-wide"
            icon={<FaDollarSign />}
            color="#8B5CF6"
          />
        </div>

        <div className="dashboard-sections">
          <div className="recent-projects">
            <h3>Recent Projects</h3>
            <ProjectList />
          </div>

          <div className="quick-actions">
            <QuickActions />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
